var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-software d-flex align-items-center",attrs:{"elevation":"2"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"texto-nivel"},[_vm._v(_vm._s(_vm.nivel.descricao))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }